let LocalDB = {},
	localStorage = window.localStorage;

LocalDB.isSupported = () => {
	return typeof(Storage) !== "undefined";
}

LocalDB.insert = (key, value) => {
	if(LocalDB.isSupported){
		localStorage.setItem(key, JSON.stringify(value));
	}
	else{
		console.log("LocalStorage not supported");
	}
};

LocalDB.fetch = (key) => {
	if(LocalDB.isSupported){
		return JSON.parse(localStorage.getItem(key));
	}
	else{
		console.log("LocalStorage not supported");
	}
};

LocalDB.delete = (key, value) => {
	if(LocalDB.isSupported){
		localStorage.removeItem(key);
	}
	else{
		console.log("LocalStorage not supported");
	}
};

LocalDB.flush = () => {
	if(LocalDB.isSupported){
		localStorage.clear();
	}
	else{
		console.log("LocalStorage not supported");
	}
};

export default LocalDB;



// WEBPACK FOOTER //
// ./src/utils/localDB.js